import { routes } from "@/constants/routes";

/** Vormerkung je Akte. Die URL trägt keinen notice-Parameter. */
const pendingByCase = new Map<string, string>();

export function stageFinderCaseNotice(caseId: string, notice: string): void {
  const text = notice.trim();
  if (!caseId || !text) return;
  pendingByCase.set(caseId, text);
}

export function readFinderCaseNotice(caseId: string | null | undefined): string | null {
  if (!caseId) return null;
  return pendingByCase.get(caseId) ?? null;
}

/** Einmal gelesen: der nächste Aufruf der Akte findet nichts mehr. */
export function consumeFinderCaseNotice(caseId: string | null | undefined): void {
  if (!caseId) return;
  pendingByCase.delete(caseId);
}

export function finderCaseHref(caseId: string, notice: string | null | undefined): string {
  if (notice) stageFinderCaseNotice(caseId, notice);
  return routes.myAnimal(caseId);
}

export function resetFinderCaseNotices(): void {
  pendingByCase.clear();
}

export function resetFinderCaseNoticesForTests(): void {
  resetFinderCaseNotices();
}
